<template>

    <div >
        <div class="head">
            {{tx.SysTitleCard}}
        </div>
        <div class="subhead">
            {{tx.AnswerQueCards}}
        </div>

    </div>
    <div class="footerParagraph">


        <div class="subHeadDes">
            {{tx.ThemeTypesCards}}
        </div>
        <div class="subhead">
            {{tx.ThemeTypesDes}}
        </div>
        <div class="paragraph">
            <table >
                <tr>
                    <td class="iconTable">
                        <i class="fa-light fa-chart-network"></i>
                    </td>
                    <td>
                        <div class="tableIconTextTitle">
                            {{tx.TrendCards}}
                        </div>
                        <div class="tableTextWlc">
                            {{tx.TrendDesCards}}
                        </div>
                    </td>
                    <td class="iconTable">
                        <i class="fal fa-thumbtack"></i>
                    </td>
                    <td>
                        <div class="tableIconTextTitle">
                            {{tx.SignalCards}}
                        </div>
                        <div class="tableTextWlc">
                            {{tx.SignalDesCards}}
                        </div>
                    </td>

                </tr>
                <tr>
                    <td class="iconTable">
                        <i class="fal fa-lightbulb-on"></i>
                    </td>
                    <td>
                        <div class="tableIconTextTitle">
                            {{tx.IdeaCards}}
                        </div>
                        <div class="tableTextWlc">
                            {{tx.IdeaDesCards}}
                        </div>
                    </td>
                    <td class="iconTable">
                        <i class="fal fa-low-vision"></i>
                    </td>
                    <td>
                        <div class="tableIconTextTitle">
                            White Spot
                        </div>
                        <div class="tableTextWlc">
                            {{tx.WSDesCards}}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="iconTable">
                        <i class="fal fa-lock"></i>
                    </td>
                    <td>
                        <div class="tableIconTextTitle">
                            Givens
                        </div>
                        <div class="tableTextWlc">
                            {{tx.GivenDesCards}}
                        </div>
                    </td>

                </tr>
            </table>
        </div>
    </div>
    <div class="paragraph">
        <div class="subHeadDes">
            {{tx.SteepFactors}}
        </div>
        <div class="subhead">
            {{tx.SteepFactorsDes}}
        </div>

    </div>
   
</template>
<script>
    import $ from 'jquery';
    export default {
        name: 'Systematisierung',
        components: {
        },
        data() {
            return {

                tx: {
                  
                    SysTitleCard: this.$LanguageProvider.GetResource("SysTitleCard", "Caption", "Systematisierung der Themen im Horizon Scanning"),
                    SuchfelderDesCards: this.$LanguageProvider.GetResource("SuchfelderDesCard", "Caption", "Die Themen sind in den nachfolgenden Suchfeldern organisiert. Wählen Sie Ihren Themenfeld-Einstieg und entdecken Sie die redaktionell ausgearbeiteten Themenkarten."),
                    QuesTitleCards: this.$LanguageProvider.GetResource("QuesTitleCards", "Caption", "Wie werden die Inhalte systematisiert?"),
                    AnswerQueCards: this.$LanguageProvider.GetResource("AnswerQueCards", "Caption", "Die Themen werden nach thematischen Gebieten sortiert (Suchfelder) und gleichzeitig nach der Art des Themas eingestuft (Thementypen)."),
                    ThemeTypesCards: this.$LanguageProvider.GetResource("ThemeTypesCards", "Caption", "THEMENTYPEN"),
                    SteepFactors: this.$LanguageProvider.GetResource("SteepFactors", "Caption", "STEEP-VL FAKTOREN"),
                    TrendCards: this.$LanguageProvider.GetResource("TrendCards", "Caption", "Trend"),
                    AllSearchfields: this.$LanguageProvider.GetResource("AllSearchfields", "Caption", "Alle Suchfelder"),
                    All: this.$LanguageProvider.GetResource("All", "Caption", "Alle"),
                    TrendDesCards: this.$LanguageProvider.GetResource("TrendDesCards", "Caption", " Ein Thema, für das im Zeitverlauf bereitsmehrere Belege existieren und das sich erkennbar in eine Richtung weiterentwickelt."),
                    SteepFactorsDes: this.$LanguageProvider.GetResource("SteepFactorsDes", "Caption", "Neben der Einteilung nach Thementypen werden die Themen der Plattform den STEEP-VL-Faktoren zugeordnet. Die englische Abkürzung STEEP-VL steht für Social, Technological, Economical, Ecological, Political, Values und Legal. Es geht also darum, inwiefern das Thema soziale, technologische, ökonomische, ökologische, politische, ethische und rechtliche Auswirkungen hat. Die Analyse der STEEP-VL-Faktoren ist eine in der Zukunftsforschung vielfach angewandte Methode zur Systematisierung möglicher Einflussfaktoren im Umfeld einer Organisation. Ziel ist der umfassende Überblick über diese Faktoren sowie die Einschätzung ihrer Relevanz und der gegenseitigen Wechselwirkungen."),
                    SignalCards: this.$LanguageProvider.GetResource("SignalCards", "Caption", "Signal"),
                    IdeaCards: this.$LanguageProvider.GetResource("IdeaCards", "Caption", "Idee"),
                    IdeaDesCards: this.$LanguageProvider.GetResource("IdeaDesCards", "Caption", "  Die Idee bezeichnet ein Konzept oder einen Ansatz, der bisher nur auf der konzeptionellen Ebene existiert - oft mit großen Disruptionspotenzialen einhergeht. Dabei ist die Eintrittswahrscheinlichkeit erstmals völlig unklar, da sich die Gesellschaft positionieren muss."),
                    SignalDesCards: this.$LanguageProvider.GetResource("SignalDesCards", "Caption", " Ein Signal ist ein erstes Anzeichen für etwas Neues, das für bestimmte Entwicklungen (Trends) als relevant eingestuft wird und potenziell einen bedeutenden Einfluss entwickeln könnte. Diese schwachen Signale haben oft besondere Aspekte, welche vom Blickwinkel des Scouts abhängen und nicht offensichtlich sind."),
                    WSDesCards: this.$LanguageProvider.GetResource("WSDesCards", "Caption", " Der White Spot bezeichnet den blinden Fleck. Diese charakterisiert Themen, die bisher nicht erkannt, übersehen oder unterschätzt wurden, obwohl Sie in Zukunft eine beachtliches Momentum erzeugen können. Sie sind schwer zu erkennen, da Sie teils außerhalb des Zuständigkeitsbereichs des BMAS liegen, bzw. erst durch die Bewertungen der BMAS Foresight Community erkennbar sind."),
                    GivenDesCards: this.$LanguageProvider.GetResource("GivenDesCards", "Caption", "Givens bezeichnet den Thementyp der gesetzten oder schwer veränderbaren Rahmenbedingungen, die eine Relevanz für aktuelle und zukünftige Entwicklungen aufweisen. Diese müssen in Möglichkeits- und Entscheidungsdenken zwingend berücksichtigt werden, da sie kaum veränderbar sind. Dies können zum Beispiel physikalische naturwissenschaftliche Gesetzmäßigkeiten, Gesetze & Richtlinien, Normen, Infrastrukturelle Gegebenheiten oder Korrelationen sein."),
                    ThemeTypesDes: this.$LanguageProvider.GetResource("ThemeTypesDes", "Caption", "Beim Horizon Scanning wird ein breites Spektrum von schwachen Signalen, neuen oder bekannten Themen bis hin zu disruptiven Entwicklungen erfasst. Die Themen aus dem Scanning werden daher auf Denkfabrik.AI verschiedenen Thementypen wie Trend, Idee oder White Spot zugeteilt. Je nach Charakter des Thementyps erfolgt eine unterschiedliche redaktionelle Ausarbeitung in der Detailansicht eines Themas. Die fünf Thementypen erklärt:"),
                    SearchTextTitle: this.$LanguageProvider.GetResource("SearchTextTitle", "Caption", "Suchbegriff:"),
                    SuggestHitCaption: this.$LanguageProvider.GetResource("SuggestHitCaption", "Caption", " Teilen Sie uns mit, was Sie an diesem Thema spannend für die Arbeitswelt von morgen finden. Unsere Redaktion prüft und ergänzt jeden Vorschlag. Egal ob, der Wirtschaftsartikel aus Ihrer Morgenlektüre, Tweets spannende Kon-zeptansätze bzw. Ihr neuestes Lieblingspaper zu Workingout Loud – jeder In-put im Kontext der Arbeitswelt hilft uns dabei, gemeinsam die Aspekte der Ar-beitswelt von morgen zu entdecken und im BMAS zu interpretieren. Machen Sie mit!")

                },
            };
        },
        computed: {

        },
        props: {
          

        },
        watch: {
         
        },
        created: function () {
        },
        mounted: function () {
            $('#qhpForm').hide();
        },

        methods: {


         
        }
    }
</script>
<style scoped>
    .vdSuchfelder {
        display: flex;
        flex-direction: column;
    }

    .tableTextWlc {
        color: var(--icon-table-text-color);
        padding-left: 10px;
        width: 400px;
        font-size: var(--icon-table-text-size);
        padding-top: 5px;
    }

    .tableIconTextTitle {
        font-weight: bold;
        color: #00a5c3;
        padding-left: 10px;
        width: 200px;
        font-size: 15px;
        padding-top: 10px;
    }

    .iconTable > i {
        margin-bottom: 12px;
        color: var(--topicCardview-icon-color);
        font-size: 60px;
        padding-left: 10px;
    }

    .fa-regular {
        color: #00a5c3;
    }

    td {
        padding-bottom: 20px;
        vertical-align: top;
    }

    .iconTable {
        width: 105px;
        padding-left: 30px;
    }

    .paragraph {
        padding-bottom: 80px;
    }

    .tsBtnDx {
        width: 130px;
        background-color: var(--m02-color-1);
        margin-bottom: 10px;
        margin-top: 20px;
        padding: 7px;
    }

    .tsBtnÜbersicht {
        width: 170px;
        background-color: var(--m02-color-1);
        margin-bottom: 20px;
        margin-top: 20px;
        padding: 7px;
    }


    .tsAddNew {
        width: 178px;
        background-color: var(--m02-color-1);
        margin: 0px 0px 20px 0px;
        height: 36px;
        padding: 7px;
    }

        .tsAddNew:hover, .tsBtnDx:hover, .tsBtnÜbersicht:hover {
            background-color: var(--danger-hover-color);
            box-shadow: 0px 0px 5px 0px rgb(255 255 255 / 50%);
        }

    .head {
        padding-top: 20px;
    }

    .btnAll div {
        margin-right: 10px;
    }

    #QuickHelpBox .portlet-content {
        display: none;
    }

    .vdContents {
        display: contents;
    }

    .vdFilterControls {
        display: flex;
        gap: 5px;
    }

    .vdInnerBox {
        display: grid;
        grid-template-columns: repeat(auto-fit, 280px);
        grid-template-rows: repeat(400px);
        gap: 50px;
        width: 100%;
        max-width: 100%;
    }

    .vdFilter {
        margin: 0 0 10px;
    }

    body #SheetContentContainer .CpContent {
        padding: 0 10px 0 10px;
    }

    .vdBody {
        display: grid;
        grid-template-rows: auto;
        width: 100%;
        height: 100%;
        border: solid 1px #d8d4d4;
        padding: 10px;
        padding-bottom: 0px;
        align-content: start;
        border-radius: 3px;
    }

        .vdBody:hover {
            box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 10%);
        }

    .vdVideoPlayer {
        width: 100%;
        height: 100%;
    }

    .subhead {
        padding-bottom: 20px;
        font-size: var(--page-description-text-size);
        max-width: 700px;
    }

    .subHeadDes {
        color: var(--topicCardview-subhead-description-color);
        padding-bottom: 20px;
        font-size: var(--topicCardview-subhead-description-size);
        font-weight: bold;
        padding-bottom: 10px;
    }

    .vdId, .vdTitle {
        font-weight: bold;
        font-size: 12px;
        padding-top: 11px;
    }

    .vdAuthor, .vdLength {
        font-size: 11px;
    }

    @media only screen and (max-width:699px) {
        div#frmMain {
        }
    }

    @media only screen and (max-width:699px) {
    }

    .vdFooter {
        display: grid;
        grid-template-columns: auto;
    }

    .vdTitle {
        grid-row: 2;
        grid-column: 1;
        border-top: solid 1px #d8d4d4;
        margin-top: 10px;
    }

    .vdTfiName {
        grid-row: 1;
        grid-column: 1;
        font-size: 11px;
    }

    .vdRating {
        grid-row: 1 / 3;
        grid-column: 2;
        display: grid;
        grid-template-columns: auto auto;
        justify-self: end;
        align-self: end;
        width: 90px;
        color: gray;
    }

    .vdRat {
        display: grid;
        grid-template-columns: auto auto;
    }

    .vdIcon {
        font-size: 36px;
        cursor: pointer;
        color: var(--danger-hover-color);
        margin: 10px 10px 10px 0;
        vertical-align: middle;
    }

        .vdIcon:hover {
            color: var(--flag-color-4);
        }

    .vdAuthor, vdLength {
        grid-column: 1 / 2;
    }

    .vdAuthor {
        grid-row: 2;
        grid-column: 1;
    }

    .vdVote {
        color: var(--flag-color-4);
    }

    .vdLength {
        grid-row: 3;
        grid-column: 1;
    }

    .vdArticel .vdBody img {
        width: 280px;
        height: 280px;
        object-position: center;
        object-fit: contain;
        background: white;
        align-self: self-end;
    }

        .vdArticel .vdBody img:hover {
            filter: grayscale(100%);
        }

    .vdArticel:hover {
        cursor: pointer;
    }


    .vdFilterBox {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        justify-content: space-between;
    }

    .vdFilterRight {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        justify-content: space-between;
        gap: 15px;
    }

    .vdFilterCell .dx-item-content {
        display: flex;
        flex-direction: row;
        /* justify-content: center; */
        align-items: center;
        /* margin: 0; */
        /* padding: 0; */
    }

    .vdTtyName {
        display: inline-block;
    }

    .vdFilterBox {
        display: flex;
        gap: 10px;
        align-content: baseline;
        align-items: center;
    }

    .vdEmpty {
        display: flex;
        justify-content: center;
        padding-top: 50px;
        font-size: 25px;
    }

    .vdDice i {
        font-size: 37px;
        color: var(--danger-color);
        cursor: pointer;
    }

        .vdDice i:hover {
            color: var(--m01-color-1)
        }

    .vdFilterLeft {
        display: flex;
        flex-direction: row;
        gap: 40px;
        align-items: baseline;
    }

    .vdSuchfeld {
        font-size: var(--topicCardview-suchfeld-detail-size);
        color: var(--topicCardview-suchfeld-detail-color);
        font-weight: bold;
        padding-bottom: 6px;
        padding-top: 20px;
    }

    .footerParagraph {
        padding-top: 20px;
    }

    .dx-state-invisible {
        display: block !important;
    }

    .vdFilterCell .dx-item-content {
        display: flex;
    }

    .vdIcon .tooltiptext {
        visibility: hidden;
        width: 120px;
        color: black;
        background-color: var(--page-bg-color);
        font-family: var(--font-family);
        font-size: 12px;
        margin-left: 10px;
        /*text-align: center;*/
        border-radius: 6px;
        padding: 10px;
        /* Position the tooltip */
        position: absolute;
        box-shadow: 1px 2px 6px #888888;
        width: auto;
        max-width: 500px;
        z-index: 1;
        line-height: 1.3em;
    }

    .vdIconTag .tooltiptext {
        visibility: hidden;
        width: 120px;
        color: black;
        background-color: var(--page-bg-color);
        font-family: var(--font-family);
        font-size: 12px;
        margin-left: 69px;
        margin-top: -20px;
        /*text-align: center;*/
        border-radius: 6px;
        padding: 10px;
        /* Position the tooltip */
        position: absolute;
        box-shadow: 1px 2px 6px #888888;
        width: auto;
        max-width: 500px;
        z-index: 1;
        line-height: 1.3em;
    }

    .vdIcon:hover .tooltiptext {
        visibility: visible;
    }

    .vdIconTag:hover .tooltiptext {
        visibility: visible;
    }

    .dx-widget.dx-button.dx-button-mode-contained.dx-button-normal.dx-button-has-text.dx-button-has-icon {
        background-color: var(--danger-color);
    }
</style>
